export default{
  fetchStorage(storage_key){
    return JSON.parse(window.localStorage.getItem(
      storage_key||"[]"))
  },
  saveStorage(storage_key,items){
    window.localStorage.setItem(storage_key,JSON.stringify(items))
  },
  removeStorage(){
    window.localStorage.removeItem("user")
  }
}



// WEBPACK FOOTER //
// ./src/commons/common.js